/**
 * @generated SignedSource<<6c40ed07cbf814859fcd1d8d861886a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionApproverStatus = "APPROVED" | "DECLINED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type approvalDrawer_softwareReleasesApprovers_jiraVersionApprover$data = {
  readonly status: JiraVersionApproverStatus;
  readonly " $fragmentSpreads": FragmentRefs<"approvalDescription_softwareReleasesApprovers" | "declineReason_softwareReleasesApprovers" | "removeApprover_softwareReleasesApprovers_jiraVersionApprover">;
  readonly " $fragmentType": "approvalDrawer_softwareReleasesApprovers_jiraVersionApprover";
};
export type approvalDrawer_softwareReleasesApprovers_jiraVersionApprover$key = {
  readonly " $data"?: approvalDrawer_softwareReleasesApprovers_jiraVersionApprover$data;
  readonly " $fragmentSpreads": FragmentRefs<"approvalDrawer_softwareReleasesApprovers_jiraVersionApprover">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "approvalDrawer_softwareReleasesApprovers_jiraVersionApprover",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "FragmentSpread",
      "name": "declineReason_softwareReleasesApprovers"
    },
    {
      "kind": "FragmentSpread",
      "name": "approvalDescription_softwareReleasesApprovers"
    },
    {
      "kind": "FragmentSpread",
      "name": "removeApprover_softwareReleasesApprovers_jiraVersionApprover"
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "9a8c096db46dae97f3dee130dd9f5252";

export default node;
